export const getPageNumberFromOffsetParam = (
  offsetParam: string,
  galleryPageSize: number,
): number => {
  const offset =
    offsetParam === undefined || offsetParam === '' ? 0 : Number(offsetParam)
  if (Number.isNaN(offset) || offset < 0) {
    return 1
  }
  return Math.floor(offset / galleryPageSize) + 1
}
